// extracted by mini-css-extract-plugin
module.exports = {"toggle_pass":"styles_toggle_pass__586ov"};